module.exports = __webpack_public_path__ + "static/media/intro.eb55fec1.mp3";